import { useReset } from '@/hooks';
import { IToggleTrigger } from '@/hooks/useToggle';
import { useWebViewRouter } from '@/hooks/useWebViewRouter';
import { cartDatas } from '@/types/main';
import { Image } from '../Image';
import { FormattedMessage } from 'react-intl';
import { trackEvent } from '../Event/_lib/eventTrack';

interface IProps {
  cartData: cartDatas[] | undefined;
  menuModal: IToggleTrigger;
  companyModalOpen: () => void;
  backModalOpen: () => void;
}

const MenuModal = ({ cartData, menuModal, companyModalOpen, backModalOpen }: IProps) => {
  const { resetCart, goHome } = useReset();
  const { direct } = useWebViewRouter();

  return (
    <div
      className="bg-white text-[16px] font-medium w-[220px] rounded-[10px] border shadow-[4px_4px_16px_0_rgba(0,0,0,0.10)] border-[#f5f5f5] flex flex-col  justify-between absolute top-[73px] right-[25px] z-50"
      onClick={(e) => {
        menuModal.close();
        e.stopPropagation();
      }}
    >
      <div
        className="p-4 gap-2 flex items-center"
        onClick={() => {
          trackEvent('PLP_click_Restart');
          if (cartData && cartData.length > 0) {
            backModalOpen();
          } else {
            resetCart();
            goHome();
          }
        }}
      >
        <Image alt={'reset-icon'} width={20} height={20} src={'/icons/reset-black.svg'} />
        <FormattedMessage id="restart" defaultMessage="Restart" />
      </div>
      <div
        className="p-4 gap-2 flex items-center"
        onClick={() => {
          direct('/promotion');
          trackEvent('PLP_Click_Tutorial');
        }}
      >
        <Image alt={'reset-icon'} width={20} height={20} src={'/icons/tutorial.svg'} />
        <FormattedMessage id="tutorial" defaultMessage="Tutorial" />
      </div>
      <div className="p-4 gap-2 flex items-center" onClick={companyModalOpen}>
        <Image alt={'reset-icon'} width={20} height={20} src={'/icons/shop.svg'} />
        <FormattedMessage id="company-information" defaultMessage="Company Information" />
      </div>
    </div>
  );
};

export default MenuModal;
